import { fetchStudents, resetStudentData } from '../../actions/studentsByOrg'
import { addFetchAction, removeFetchAction } from '../../actions/app'
import { CoordinatorStudents } from '../../components/students'

const mapStateToProps = state => {
  const {
    status: { fetched },
    user: {
      data: { isLevelTwo },
    },
  } = state
  return {
    statusLoaded: fetched || !isLevelTwo,
  }
}

const StudentsPage = ({
  fetchStudents,
  resetStudentData,
  addFetchAction,
  removeFetchAction,
  statusLoaded,
}) => {
  useEffect(() => {
    addFetchAction({
      name: 'fetchStudents',
      action: (orgId, educationPeriodCd) => fetchStudents(orgId, educationPeriodCd),
    })
    return () => removeFetchAction('fetchStudents')
  }, [])

  useEffect(() => {
    return () => resetStudentData()
  }, [])

  if (statusLoaded)
    return (
      <CSSTransition
        classNames="animate-fade"
        in={true}
        timeout={500}
        appear={true}
        enter={false}
        exit={false}
      >
        <CoordinatorStudents />
      </CSSTransition>
    )

  return null
}

export default connect(mapStateToProps, {
  fetchStudents,
  resetStudentData,
  addFetchAction,
  removeFetchAction,
})(StudentsPage)
